import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import KsbDialogActions from "../../../../2_ksbHub/components/KsbDialogActions";

export default function AddShiftDialog({ open, onClose, onSave, initialData }) {
  const [label, setLabel] = useState("");
  const [time, setTime] = useState("");
  const isEditMode = !!initialData;

  useEffect(() => {
    if (initialData) {
      setLabel(initialData.label);
      setTime(initialData.time);
    } else {
      setLabel("");
      setTime("");
    }
  }, [initialData, open]);

  const handleSave = () => {
    onSave({
      id: initialData?.id || `shift-${Date.now()}`,
      label,
      time,
    });

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>
        {isEditMode ? "Schicht bearbeiten" : "Neue Schicht"}{" "}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label="Bezeichnung (z.B. Schicht B)"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            fullWidth
          />

          <TextField
            label="Zeit (z.B. 19:30–21:30)"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            fullWidth
          />
        </Stack>
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={handleSave}
        confirmLabel="Speichern"
        confirmDisabled={!label.trim()}
      />
    </Dialog>
  );
}
